import auth from '../../../config/app-specific-config/auth'
import * as types from './dsr-faq-actions-type'
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig'

// SET
export const setDsrFaqContent = (p) => {
	return {
		type: types.SET_DSR_FAQ_CONTENT,
		payload: p
	};
};

// GET
export const getDsrFaqContentSuccess = (response) => {
	return {
		type: types.GET_DSR_FAQ_CONTENT_SUCCESS,
		payload: response
	};
};

export const getDsrFaqContentFailure = (error) => {
	return {
		type: types.GET_DSR_FAQ_CONTENT_FAILURE,
		error
	};
};

export const getDsrFaqContentRequest = () => {
	return {
		type: types.GET_DSR_FAQ_CONTENT_REQUEST
	};
};

export function getDsrFaqContent(dsrId) {
	
	return async (dispatch) => {
		dispatch(getDsrFaqContentRequest());
		try {
			const url = `/dsr/faq/content/${dsrId}`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.get(
				url,
				{headers}
			);
			
			dispatch(setDsrFaqContent(response.data.data.dsrFaqContent || []))
			dispatch(getDsrFaqContentSuccess(response));
			
			
				
		} catch (error) {
			dispatch(getDsrFaqContentFailure(error));
		}
	};
}

// Create-Edit

export const manageDsrFaqContentSuccess = (response) => {
	return {
		type: types.MANAGE_DSR_FAQ_CONTENT_SUCCESS,
		payload: response
	};
};

export const manageDsrFaqContentFailure = (error) => {
	return {
		type: types.MANAGE_DSR_FAQ_CONTENT_FAILURE,
		error
	};
};

export const manageDsrFaqContentRequest = () => {
	return {
		type: types.MANAGE_DSR_FAQ_CONTENT_REQUEST
	};
};

export function manageDsrFaqContent(manageDsrFaqContentPayload) {
	
	return async (dispatch) => {
		dispatch(manageDsrFaqContentRequest());
		try {
			const url = `/dsr/faq/manage`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				manageDsrFaqContentPayload,
				{ headers }
			);
			const { updatedDsrFaqContent, ...destructuredResponse} = response.data.data || {}
			
			if (updatedDsrFaqContent) {
				dispatch(setDsrFaqContent(updatedDsrFaqContent))
			}

			dispatch(manageDsrFaqContentSuccess({...destructuredResponse, processingCompleted: true}));
			

		} catch (error) {
			dispatch(manageDsrFaqContentFailure(error));
		}
	};
}

// Reset
export const manageDsrFaqContentReset = () => {
	return {
		type: types.RESET_MANAGE_DSR_FAQ_CONTENT
	};
};

export function resetManageDsrFaqContent() {

	return async (dispatch) => {
		try {
			dispatch(manageDsrFaqContentReset());

		} catch (error) {
			dispatch(manageDsrFaqContentFailure(error));
		}
	};
}